export function getUserLocation() {
  try {
    return new Promise((resolve, reject) => {
      navigator.geolocation.getCurrentPosition(
        location => resolve({ currentLocation: location }),
        error => reject({ error: error }),
      )
    });
  } catch (e) {
    return e;
  }

}
